import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 21V3h9.6l.427 2.118H20v10.588h-7.467l-.426-2.118H6.133V21zm10.293-7.412h3.574V7.235h-5.6l-.427-2.117H6.133v6.353h7.734z"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
